<template>
    <div class="profile-product-list-skeleton">
        <v-row>
            <v-col cols="6" sm="6" md="3" v-for="i in itemsCount" :key="i">
                <div class="d-flex">
                    <v-skeleton-loader
                            min-width="150px"
                            class="mb-3 px-md-4"
                            type="card, list-item-three-line, actions"
                            :boilerplate="false"
                    ></v-skeleton-loader>
                </div>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    export default {
        name: "ProfileProductListSkeleton",
        props: ['itemsCount'],
        components:{
            VBoilerplate: {
                functional: true,

                render (h, { data, props, children }) {
                    return h('v-skeleton-loader', {
                        ...data,
                        props: {
                            boilerplate: true,
                            elevation: 2,
                            ...props,
                        },
                    }, children)
                },
            }
        },
    }
</script>

<style scoped>

</style>
